import {Component, Input, OnInit} from '@angular/core';
import {Media} from "../../models/media";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-media-selection-modal',
    templateUrl: './media-selection-modal.component.html',
    styleUrls: ['./media-selection-modal.component.scss']
})
export class MediaSelectionModal implements OnInit {

    @Input() media: Array<Media>;
    @Input() code: string;

    constructor(
        public activeModal: NgbActiveModal
    ) {
    }

    ngOnInit() {
    }

    onSelect(media: Media) {
        this.activeModal.close(media);
    }
}
